import { createAction } from 'redux-act';
import { TLegacyErrors } from '@alycecom/services';

import { IBaseRequestParams } from '../../../../store/types/Request.types';

import { ISendFinishInfoParams } from './finishInfo.types';

const PREFIX = 'RECIPIENT/FINISH_INFO';

export const finishInfoRequest = createAction<IBaseRequestParams>(`${PREFIX}/FINISH_INFO_REQUEST`);
export const finishInfoSuccess = createAction<{ message: string }>(`${PREFIX}/FINISH_INFO_SUCCESS`);
export const finishInfoFail = createAction<TLegacyErrors>(`${PREFIX}/FINISH_INFO_FAIL`);

export const finishInfoSendRequest = createAction<ISendFinishInfoParams>(`${PREFIX}/FINISH_INFO_SEND_REQUEST`);
export const finishInfoSendSuccess = createAction<void>(`${PREFIX}/FINISH_INFO_SEND_SUCCESS`);
export const finishInfoSendFail = createAction<TLegacyErrors>(`${PREFIX}/FINISH_INFO_SEND_FAIL`);
